import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {OphXButtonComponent} from '../../design/oph-x-button/oph-x-button.component';

export interface ImageViewerDialogData {
  imageUrl: string;
  title?: string;
}

@Component({
  selector: 'image-viewer-dialog',
  standalone: true,
  imports: [OphXButtonComponent],
  templateUrl: './image-viewer-dialog.component.html',
  styleUrl: './image-viewer-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageViewerDialogComponent {
  data = inject<ImageViewerDialogData>(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<ImageViewerDialogComponent>);
}
